<template>
  <div
    class="KoioteValueLabelWrite"
    :style="valueLabelStyle"
  >
    <div
      v-if="!editingValue"
      class="custom-cursor"
    >
      <p
        :id="labelId"
        class="value-container"
        @click="editingValue = !editing && allowed"
      >
        {{ label }} {{ value }} {{ units }}
      </p>
    </div>
    <KoioteNumericKeyboard
      v-if="editingValue"
      :title="title"
      :original_value="value"
      :max_value="max_value"
      :min_value="min_value"
      @submit="submit"
      @cancel="editingValue = false"
    />
  </div>
</template>

<script>
import { Buffer } from "buffer";

import { mapState, mapGetters, mapActions } from "vuex";

import KoioteNumericKeyboard from "@/components/utils/KoioteNumericKeyboard.vue";

export default {
  name: "KoioteValueLabelWrite",

  components: {
    KoioteNumericKeyboard,
  },

  props: {
    input: Object,
  },

  data() {
    return {
      editingValue: false,
      labelId: "",
    };
  },

  computed: {
    ...mapState(["editing"]),

    valueLabelStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "100%",
        height: "100%",
        position: "absolute",
        alignContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
      };
    },

    connection_type() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection")).settings
        .component_type;
    },

    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.topic_write;
    },

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.vartable;
    },

    label() {
      return this.input.customized?.label?.length > 0 ? `${this.input.customized.label}: ` : "";
    },

    units() {
      return this.input.customized?.units?.length > 0 ? `${this.input.customized.units}` : "";
    },

    allowed() {
      return this.input.customized?.permission_address?.length > 0
        ? this.vartable?.find((v) => v.formatted_address == this.input.customized.permission_address)?.value || 0
        : true;
    },

    value() {
      const retrievedValue =
        this.vartable?.find((v) => v.formatted_address == this.input.customized.address)?.value || 0;

      const applicableRetrievedValue = retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;

      return typeof applicableRetrievedValue === "boolean"
        ? applicableRetrievedValue
          ? this.input.customized.true_text
          : this.input.customized.false_text
        : this.input?.customized?.datatype == "ENTERO"
        ? Math.round(applicableRetrievedValue)
        : applicableRetrievedValue > 1000
        ? Math.round(applicableRetrievedValue).toFixed(2)
        : (Math.round(applicableRetrievedValue * 100) / 100).toFixed(2);
    },

    max_value() {
      return this.input.customized.max_value;
    },

    min_value() {
      return this.input.customized.min_value;
    },

    title() {
      return this.input.customized.title;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["doPublish"]),

    generateId() {
      return Math.random().toString(36).slice(2);
    },

    submit(value) {
      const number_to_write = parseFloat(value) / this.input.customized.scale;
      const rawAddress = this.vartable.find((v) => v.formatted_address == this.input.customized.address)?.address;

      if (rawAddress)
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: rawAddress,
            value: this.adaptFormat({ type: this.input.customized.datatype, value: number_to_write }),
          },
        });

      this.editingValue = false;
    },

    cancel() {
      this.editingValue = false;
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return this.connection_type == "koiote-omron-connection"
              ? (() => {
                  const buffer = Buffer.allocUnsafe(4);
                  let valor = parseFloat(item.value);
                  buffer.writeFloatBE(valor);
                  let d = [];
                  d[0] = 256 * buffer[2] + buffer[3];
                  d[1] = 256 * buffer[0] + buffer[1];
                  console.log(d);
                  return d;
                })()
              : Number(item.value);
          default:
            return "";
        }
      })();
    },

    updateHeight() {
      const textElement = document.getElementById(this.labelId);
      const textElementHeight = textElement.getBoundingClientRect().height;

      const containerElement = textElement.parentElement?.parentElement;
      const containerElementHeight = containerElement?.getBoundingClientRect().height;

      if (textElementHeight > containerElementHeight) {
        containerElement.parentElement.style.height =
          this.input.customized.height * (textElementHeight / containerElementHeight || 1) + 2 + "%";
      }
    },
  },

  created() {
    this.labelId = this.generateId();
    window.addEventListener("resize", this.updateHeight);
    this.$nextTick(() => {
      this.updateHeight();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateHeight);
  },
};
</script>

<style scoped>
.value-container {
  margin: 0;
  padding: 0;
}

.custom-cursor {
  cursor: pointer;
}

.KoioteValueLabelWrite {
  font-size: 1vw;
}

@media (orientation: portrait) {
  .KoioteValueLabelWrite {
    font-size: 1.3vw;
  }
}

@media (orientation: landscape) and (max-width: 600px) {
  .KoioteValueLabelWrite {
    font-size: 0.85vw;
  }
}

@media (orientation: portrait) and (max-width: 500px) {
  .KoioteValueLabelWrite {
    font-size: 1.55vw;
  }
}
</style>
